const handleEvents = {
  openRehireModal: null, // Will be set later
  closeRehireModal: null, // Will be set later

  setContextFunctions(context) {
    this.getContext = () => context; // Allows access to context values when needed
  },

  OnEditBackground: async (event) => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnEditBackground");
      return;
    }
    const { storeBackgroundImage } = context;

    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      storeBackgroundImage(e.target.result); // Update background with the image URL
    };
    reader.readAsDataURL(file);
  },

  OnSetActiveTemplate: (template) => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnReactivate");
      return;
    }
    const {
      staffDetail,
      storeActiveTemplate,
      storeTextsAfterTemplateChanged,
      storeImagesAfterTemplateChanged,
      storeBackgroundColor,
      storeBackgroundImage,
    } = context;

    storeActiveTemplate(template);
    storeTextsAfterTemplateChanged(template?.texts ?? [], staffDetail);
    storeImagesAfterTemplateChanged(template?.images ?? [], staffDetail);

    // Update background color and image
    storeBackgroundColor(template.backgroundColor || "#ffffff");
    storeBackgroundImage(template.backgroundImage || "");
  },

  OnExportCardAsImage: async () => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnReactivate");
      return;
    }
    const { getImageURLFromCanvas, storeLoading, openModal } = context;

    storeLoading(true);

    const { blob, imageURL } = await getImageURLFromCanvas("birthday-card");

    if (!blob) {
      console.error("Image generation failed.");
      storeLoading(false);
      openModal("error", "Download Image", "Image generation failed.");
      return;
    }

    console.log("Generated Image URL:", imageURL);

    // ✅ Add a "Download Image" link
    const downloadLink = document.createElement("a");
    downloadLink.href = imageURL;
    downloadLink.download = "card.png";
    downloadLink.innerText = "Download Image";
    downloadLink.click();

    // ✅ Wait for 1 second before opening the modal
    setTimeout(() => {
      storeLoading(false);
      openModal("success", "Download image", "Completed successfully!");
    }, 1000);
  },

  OnSendEmail: async () => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnReactivate");
      return;
    }
    const {
      getImageURLFromCanvas,
      uploadImageAndSendEmail,
      storeLoading,
      openModal,
    } = context;

    storeLoading(true);

    const { blob, imageURL } = await getImageURLFromCanvas("birthday-card");

    if (!blob) {
      console.error("Image generation failed.");
      storeLoading(false);
      openModal("error", "Sent Card", "Image generation failed.");
      return;
    }

    console.log("Generated Image URL:", imageURL);

    // // ✅ Display Image Preview
    // const canvasContainer = document.getElementById("canvas-preview");
    // if (canvasContainer) {
    //   canvasContainer.innerHTML = "";
    //   const imgPreview = document.createElement("img");
    //   imgPreview.src = imageURL;
    //   imgPreview.width = 678;
    //   imgPreview.height = 600;
    //   canvasContainer.appendChild(imgPreview);
    // }

    // ✅ Upload the Image and Get the Permanent URL
    const uploadedAndSentEmail = await uploadImageAndSendEmail(blob);
    if (!uploadedAndSentEmail) {
      console.error("Failed to upload image.");
      storeLoading(false);
      openModal("error", "Sent Card", "Failed to upload image.");
      return;
    }
    storeLoading(false);
    openModal("success", "Sent Card", "Completed successfully!");
    return "";
  },

  OnSetActive: (id) => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnReactivate");
      return;
    }
    const { storeActiveId } = context;

    storeActiveId(id);
  },

  OnEditEnd: () => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnReactivate");
      return;
    }
    const { storeActiveId } = context;

    storeActiveId(null);
  },

  OnAddText: () => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnReactivate");
      return;
    }
    const { storeTexts, storeActiveId } = context;

    const cardElement = document.getElementById("birthday-card");
    if (!cardElement) return;

    const cardWidth = cardElement.clientWidth;
    const cardHeight = cardElement.clientHeight;

    const newText = {
      id: `text-${Date.now()}`,
      type: "text",
      content: "New Text",
      position: { x: cardWidth / 2 - 100, y: cardHeight / 2 - 14 }, // Centered
      width: 200,
      height: 28,
      fontSize: 16,
      color: "#000000",
      fontFamily: "Arial",
      fontWeight: "normal",
      backgroundColor: "none",
      isEditing: true, // Set to edit mode
    };

    storeTexts((prevTexts) => [...prevTexts, newText]);
    storeActiveId(newText.id); // Make it the active text
  },

  OnUpdateText: (updatedText) => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnReactivate");
      return;
    }
    const { storeTexts } = context;

    storeTexts((prevTexts) =>
      prevTexts.map((t) =>
        t.id === updatedText.id ? { ...t, ...updatedText } : t
      )
    );
  },

  OnRemoveText: (id) => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnReactivate");
      return;
    }
    const { storeTexts } = context;

    storeTexts((prevTexts) => prevTexts.filter((t) => t.id !== id));
  },

  OnImageUpload: async (event) => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnReactivate");
      return;
    }
    const { storeImages } = context;

    const files = Array.from(event.target.files);
    const newImages = files.map((file, index) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          resolve({
            id: `${Date.now()}-${index}`,
            src: e.target.result, // Correctly assign the image source
            position: { x: 100, y: 100 },
            width: 150, // Set default width
            height: 150, // Set default height
            shape: "square",
          });
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(newImages).then((result) => {
      storeImages((prev) => [...prev, ...result]); // Update state correctly
    });
  },

  OnUpdateImage: (updatedImage) => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnReactivate");
      return;
    }
    const { storeImages } = context;

    storeImages((prevImages) =>
      prevImages.map((img) => (img.id === updatedImage.id ? updatedImage : img))
    );
  },

  OnRemoveImage: (id) => {
    const context = handleEvents.getContext();
    if (!context) {
      console.error("Context is undefined in handleEvents.OnReactivate");
      return;
    }
    const { storeImages } = context;

    storeImages((prevImages) => prevImages.filter((img) => img.id !== id));
  },
};

export default handleEvents;
